import { useQuery } from '@apollo/client';
import { graphql } from 'gql.tada';

/**
 * Just enough to list someone's classes down the side: what each one is called
 * and where it lives. The Teaching pages ask for the same classes with their
 * schedules and attendance rolls attached; the sidebar has no use for those.
 */
const SidebarClassesQuery = graphql.persisted(
  "SidebarClassesQuery",
  graphql(`
    query SidebarClassesQuery($schoolYearId: ID!) {
      schoolYear(id: $schoolYearId) {
        id
        myClassOfferings {
          id
          displayName
          course { id slug }
          term { id name startsOn endsOn }
        }
      }
    }
  `)
);

export { SidebarClassesQuery };

export function useSidebarClassesQuery(schoolYearId?: string, skip = false) {
  return useQuery(SidebarClassesQuery, {
    variables: { schoolYearId: schoolYearId! },
    skip: skip || !schoolYearId,
  });
}
